<router-outlet>
    <app-spinner></app-spinner>
</router-outlet>
<notifier-container></notifier-container>
<app-mantenimiento-plataforma></app-mantenimiento-plataforma>
